import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import { apiPut } from "../../utils/apiFetch";
import OButton from "components/reusable/OButton";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OFile from "components/reusable/OFile";
import { validationRules } from "utils/constants";
import helper from "../../utils/helpers";
import { BiArrowBack } from "react-icons/bi";
const ViewReportDetails = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(
    location?.state?.item?.postDetails?.images || null
  );
  const [uploadedVideos, setUploadedVideos] = useState(
    location?.state?.item?.postDetails?.videos || null
  );
  const [uploadedAudio, setUploadedAudio] = useState(
    location?.state?.item?.postDetails?.audio || null
  );
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state?.item);
  const notification = useToastContext();

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      userFullName: Capitalize(editData?.userDetails?.fullName),
      userEmail: editData?.userDetails?.email,
      userId: editData?.userDetails?.userUniqueId,
      mobile: editData?.userDetails?.mobile,
      reportDateAndTime: helper?.dateFormat(editData?.createdAt) || t("O_N/A"),
      comment: editData?.comment,
      reply: editData?.reply,
      postUserFullName: Capitalize(editData?.postDetails?.postUserDetails?.fullName),
      postDescription: editData?.postDetails?.description,
      postDateAndTime:
        helper?.dateFormat(editData?.postDetails?.createdAt) || t("O_N/A"),
      postUserId:editData?.postDetails?.postUserDetails?.userUniqueId
    },
  });

  const getBack = () => {
    setRedirect(true);
    navigate("/blogs");
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      setCategories(response?.docs);
    }
  };

  const getSubCategories = (categoryId, categories) => {
    const category = categories.filter((item) => {
      return item?._id === categoryId;
    });

    setSubCategories(category[0]?.subcategories);
  };
  useEffect(() => {
    getCategories();
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue("title", editData.title ?? "");
      setValue("categoryId", editData?.category ?? "");
      setValue("subCategoryId", editData?.subCategory ?? "");
      setValue("authorName", editData?.authorName ?? "");
      setValue("description", editData?.description ?? "");
    }
  }, [editData]);

  useEffect(() => {
    getSubCategories(editData?.category, categories);
  }, [editData, categories.length]);

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <span
          className="flex  items-center cursor-pointer"
          onClick={() => navigate("/help-and-support")}
        >
          <BiArrowBack className="h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2" />
          <span className="ml-2">{t("O_BACK")}</span>
        </span>
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          {t("VIEW_REPORTED_CONTENT")}
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
              {t("USER_DETAILS")}
              </h3>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="userId"
                id="userId"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("userId")}
                />
                <label
                  htmlFor="userId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_USER_ID")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <NavLink
                  title={t("O_VIEW_USER")}
                  target="_blank"
                  to= {`/users/customer-view?id=${editData?.userDetails?._id}`}
                >
                  <input
                    type="text"
                    name="userFullName"
                    id="userFullName"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("userFullName")}
                  />
                </NavLink>

                <label
                  htmlFor="userFullName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_NAME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="userEmail"
                  id="userEmail"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("userEmail")}
                />
                <label
                  htmlFor="userEmail"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_EMAIL_ID")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="mobile"
                  id="mobile"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("mobile")}
                />
                <label
                  htmlFor="mobile"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_MOBILE")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  disabled
                  name="reportDateAndTime"
                  id="reportDateAndTime"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("reportDateAndTime")}
                />
                <label
                  htmlFor="reportDateAndTime"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_REPORT_DATE_TIME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  disabled
                  type="text"
                  name="comment"
                  id="comment"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  // maxLength={151}
                  {...register("comment")}
                />
                <label
                  htmlFor="comment"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_REPORTED_CONTENT")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>

            { editData?.isReplied && <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  disabled
                  type="text"
                  name="reply"
                  id="reply"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  // maxLength={151}
                  {...register("reply")}
                />
                <label
                  htmlFor="reply"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_REPLY")}
                </label>
              </div>
            </div>}

            {/* <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
            </div> */}
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
              {t("POST_DETAILS")}
              </h3>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                type="text"
                name="postUserId"
                id="postUserId"
                disabled
                className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                maxLength={31}
                {...register("postUserId")}
                />
                <label
                  htmlFor="postUserId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_USER_ID")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <NavLink
                  title={t("O_VIEW_USER")}
                  to= {`/users/customer-view?id=${editData?.postDetails?.postUserDetails?._id}`}
                  target="_blank"
                >
                  <input
                  type="text"
                  name="postUserFullName"
                  id="postUserFullName"
                  disabled
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("postUserFullName")}
                />
                </NavLink>
                <label
                  htmlFor="postUserFullName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_NAME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="postDateAndTime"
                  id="postDateAndTime"
                  disabled
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("postDateAndTime")}
                />
                <label
                  htmlFor="postDateAndTime"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_POST_DATE_TIME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            {editData?.postDetails?.description && <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  disabled
                  type="text"
                  name="postDescription"
                  id="postDescription"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("postDescription")}
                />
                <label
                  htmlFor="postDescription"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>}
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                  {t("UPLOADED_AUDIO")}
                  </h3>
                </div>
            {uploadedAudio?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedAudio?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                  {t("UPLOADED_IMAGES")}
                  </h3>
                </div>
            {uploadedImages?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedImages?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                  {t("UPLOADED_VIDEOS")}
                  </h3>
                </div>
            {uploadedVideos?.length > 0 ? (
                <div className="relative grid grid-cols-3 gap-3">
                  {uploadedVideos?.map((item, i) => {
                    return (
                      <div key={i}>
                        <a href={item?.url} target="_blank" rel="noreferrer">
                          <OFile
                            type={item?.type}
                            src={item?.url}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-48 h-48 border relative inline"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
            ) : t("O_N/A")}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReportDetails;
